var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('BlockUI',{attrs:{"message":_vm.content}},[_c('div',{staticClass:"box__loader"},[_c('div',{staticClass:"loader--dot"}),_vm._v(" "),_c('div',{staticClass:"loader--dot"}),_vm._v(" "),_c('div',{staticClass:"loader--dot"})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73652927","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Loader.vue
// module id = 342
// module chunks = 82